const isArrayWithLength = (arr?: any[] | null): arr is number[] => Boolean(Array.isArray(arr) && arr.length);

export default isArrayWithLength;
